export const environment = {
  production: true,
  info: {
    publicUrl: 'https://search.pcclerk.org/login',
    district: '18TH',
    city: 'NEW ROADS',
    parish: 'POINTE COUPEE',
    url: 'search.pcclerk.org',
    logo: 'seal_pc.png',
    clerkName: 'BECKY EWING MILLER',
    clerkAddress: 'PO BOX 38',
    clerkCityStateZip: 'NEW ROADS, LA  70760',
    clerkPhone: '(225) 638-9596',
    clerkWeb: 'www.pcclerk.org',
    email: 'civil@pcclerk.org',
    civilFees: 'https://pcclerk.org/wp-content/uploads/2026/01/CIVIL-FEES.pdf',
    videoUrl: 'https://firebasestorage.googleapis.com/v0/b/cn26rec_pub/o/videos%2FClerkNet_Search_Options.mp4?alt=media&token=8accd570-7280-4109-bad5-a5a28e6b2072'
  },
  civilFees: {
    subpoenas: 75,
  },
  dates: {
    civil: 689239681000,
    criminal: null,
    conveyances: null,
    mortgages: null,
    recording: null,
    marriages: null,
  },
  recaptcha: {
    siteKey: '6LdLiAkfAAAAAFPOiMQDoGm8peuoy8vPVuoIZttK'
  },
  mconfig: {
    url: 'https://meili.clerknet.app',
    apiKey: '0ee5d62592b003e15706a25744b34f72bc52d03de8a5fa523f0fded6d480c6ca',
    civil: '',
    host: 'https://meili.clerknet.app',
    api: '',
    key: '',
    criminal: '',
  },
  sb: {
    databaseurl: '',
    databasekey: '',
    i: '',
    n: '',
    url: '',
    key: ''
  },
  aconfig: {
    appId: 'RZYQ3P4JBS',
    apiKey: '18f2496e8324ee32d8167b7e51f57e6d',
    CIVIL: 'pcCivil',
    RECORDING: '',
    CRIMINAL: 'pcCriminal',
    AUDIT: 'publicAudit',
  },
  afs: {
    civ: 'cnlapccivil',
    civpub: 'cnlapccivil_pub',
    civfolder: 'cnCivil',
    crimpub: 'cnlapccriminal_pub',
    recpub: '',
    crimfolder: 'cnCriminal',
    crim: 'cnlapccriminal',
    recfolder: '',
    rec: '',
    eRecording: '',
    eFiling: 'cnlapcefiling',
  },
  firebaseConfig: {
    apiKey: "AIzaSyD0cV_1D-OXK7aQZbREQHEeStDw0QFDY7o",
      authDomain: "clerknetlapc.firebaseapp.com",
      projectId: "clerknetlapc",
      storageBucket: "clerknetlapc.appspot.com",
      messagingSenderId: "395292705593",
      appId: "1:395292705593:web:365f27ca6bda2826d1dee8"
  },
  stripe: {
    plans: [
      {
        name: '24 HOUR',
        rate: 20,
        fee: .91,
        total: 20.91,
        discount: '',
        planId: 'price_1SmIbOLGH84Y5Dh8xquvVlK9'
      },
      {
        name: '1 MONTH',
        rate: 25,
        fee: 1.06,
        total: 26.06,
        discount: '',
        planIdRenewal: 'price_1SmIeOLGH84Y5Dh8kH1yAnHZ',
        planId: 'price_1SmIdMLGH84Y5Dh825KAxxp5'
      },
      {
        name: 'YEARLY',
        rate: 300,
        fee: 9,
        total: 309.00,
        discount: '',
        planIdRenewal: 'price_1SmIewLGH84Y5Dh88RD0OIqp',
        planId: 'price_1SmIfULGH84Y5Dh8Me6YV3OI'
      }
    ],
    clerknet: 'pk_live_514ffBuFDbduv4AUe0WNSqOQXa9Ucn7XyYE4gGbHSPTQP9laJYhc0WLAC9pn8psLh7mV6Qq8NS7ta1PzSKUygzKvA00tZ0iBHHF',
    clerknetTest: '',
    civilAcct: 'acct_1RiHSTIJ0hLrrVF5',
    recAcct: 'acct_1RiHTVLGH84Y5Dh8',
    connect: '',
    recording: 'pk_live_51RiHTVLGH84Y5Dh8quH3Lf4KT1zDbOdgNABnalIsYJ1oZ0HGTjjzjFSX8K2r71DCdFEmUkqCPWgqruxsMvhuayDe00P00B4rnN',
    recordingTest: '',
    civil: 'pk_live_51RiHSTIJ0hLrrVF5MwQWpFH0wqivU4WhkNZBwuIxFvwTj81xlkb7rCUWTK1JxkK8ejqSGNhHAVQKHrdMXtWRwMSb00o0WWH2xe',
    civilTest: ''
  }
};
